import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import LegendItem from './LegendItem';
import { useSelector } from 'react-redux';

const propTypes = {
    project: PropTypes.object.isRequired,
    isStatic: PropTypes.bool
};

function SiteCardLegendItem({ project, isStatic }) {
    const structure = project.structure;

    const filters = useSelector(state => state.siteCard.filters);
    const { filteredColumnIds, filterValue } = useMemo(() => {
        let filteredColumnIds = [];
        let filterValue = '';
        filters.children.map(filter => {
            if (filter.field === 'column') {
                filteredColumnIds = filter && filter.properties.values;
            } else if (filter.field === 'siteCardName') {
                filterValue = filter && filter.properties.value;
            }
        });
        return { filteredColumnIds, filterValue };
    }, [filters]);

    const filteredColumnOrder = useMemo(() => {
        let columnOrder = structure.columnOrder;

        if (filteredColumnIds.length > 0)
            columnOrder = columnOrder.filter(
                columnId => filteredColumnIds.indexOf(columnId.toString()) > -1
            );
        return columnOrder.map(columnId => {
            const column = structure.columns[columnId];
            return {
                color: `${column.colour}59`,
                label: column.title,
                borderColor: column.colour
            };
        });
    }, [filteredColumnIds, structure.columns, structure.columnOrder]);

    const layer = {
        name: 'My Site Cards',
        styles: [
            {
                legendSpecification: [
                    {
                        type: 'fill-group',
                        fills: filteredColumnOrder
                    }
                ]
            }
        ],
        currentStyleIdx: 0
    };

    return <LegendItem layer={layer} isStatic={isStatic} />;
}

SiteCardLegendItem.propTypes = propTypes;

export default SiteCardLegendItem;
